import { Injectable } from '@angular/core';
import { SupabaseBaseHttpService } from '@examdojo/supabase';
import { from } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdminUserViewHttpService extends SupabaseBaseHttpService<'admin_users_list_view', 'public'> {
  readonly schema = 'public';
  readonly tableName = 'admin_users_list_view';

  fetchListView() {
    const query = this.supabase.client.schema('public').from('admin_users_list_view').select();

    return from(query.throwOnError().then((response) => response.data ?? []));
  }
}
